<template>
  <div class="download-wrap" style="align: center">
    <van-notice-bar color="#1989fa" background="#ecf9ff" mode="closeable">点击右上角，在浏览器中打开，即可安装</van-notice-bar>
    <!--背景图-->
    <div class="download-topimg"></div>
    <div class="down-btn" style="postion:abs">
      <img
        class="btn-app-down"
        src="../../assets/img/andriodbtn.png"
        @click="downloadapp('android')"
        alt
      >
      <img class="btn-app-down" src="../../assets/img/iosbtn.png" @click="downloadapp('ios')" alt>
      <div class="tips" v-if="androidPhone">* 腾讯应用宝、小米、华为等各大应用商店搜索“i襄阳”</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { NoticeBar } from "vant";
import CommonFunc from "@/utils/CommonFun.js";
Vue.use(NoticeBar);
export default {
  data() {
    return {
      appBuild: "",
      androidUrl: "",
      androidPhone: true
    };
  },
  created() {
    this.getAndroidUrl();
    let phoneType = CommonFunc.judgeClientType();
    if (phoneType == "ios") {
      this.androidPhone = false;
    }
  },
  methods: {
    async getAndroidUrl() {
      let appType = 0;
      let appId = "com.xiangyang.xyzw";
      // let appId = "com.xiangyang.xhb.develop";
      let url = "/sga/user/getReleaseInfo";
      let res = await axios.post(url, {
        appId: appId,
        appType: appType
      });
      this.androidUrl = res.data.respData.downLoadUrl;
    },
    downloadapp(sign) {
      if (sign == "android") {
        // android下载地址
        window.location.href = this.androidUrl;
      } else {
        // ios下载地址
        window.location.href =
          "https://itunes.apple.com/app/apple-store/1512920844?ct=web&mt=8";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.download-topimg {
  background-color: #ffffff;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-image: url("../../assets/img/downbg.png");
  background-origin: content;
  background-position: 55% 100%;
  background-size: 200% 100%;
  background-repeat: no-repeat;
}
.tips {
  font-size: 12px;
  color: #999;
}
.down-btn {
  position: absolute;
  bottom: 10%;
  left: 0;
  text-align: center;
  .btn-app-down {
    width: 243.9px;
    height: 45.55px;
    margin-bottom: 19px;
  }
}
</style>